<div class="organization-members-shell" :style="branding_style">
  <HomeNavBar @active-profile-loaded="set_active_profile" />

  <div class="p-2">
    <header class="d-flex gap-2 align-items-start mb-3">
       <button
              class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
              @click="$router.back()"
            >
              <i class="bi bi-arrow-left fs-4"></i>
            </button>

      <div>
        <h4 class="fw-bold mb-1">
          {{ organization.company_name }} — {{ organization.is_private ? 'Companies & Members' : 'Members' }}
          <span v-if="organization.is_private" class="badge bg-primary-subtle text-primary rounded-pill text-xxs ms-2"><i class="bi bi-lock-fill me-1"></i>Private organisation</span>
        </h4>
        <p class="text-muted text-xs mb-0">
          {{ organization.is_private
            ? 'Manage companies, managers, employees, invitations and approvals.'
            : 'Manage members and invitations.' }}
        </p>
      </div>
    </header>

    <nav class="d-flex gap-4 border-bottom mb-3 overflow-auto" aria-label="Organisation management">
      <button v-for="tab in management_tabs" :key="tab.key" type="button" :class="['btn border-0 rounded-0 px-1 pb-3 text-nowrap', active_management_tab === tab.key ? 'border-bottom border-3 border-primary text-primary fw-bold' : 'text-muted']" @click="active_management_tab = tab.key">
        {{ tab.label }}
        <span v-if="tab.key === 'invitations' && pending_invitations.length" class="badge bg-primary rounded-pill ms-1">{{ pending_invitations.length }}</span>
      </button>
    </nav>

    <section v-if="active_management_tab === 'overview'" class="organization-members-stats">
      <div v-if="organization.is_private" class="organization-stat-card"><div><p>Companies</p><strong>{{ company_stats.total }}</strong></div></div>
      <div class="organization-stat-card"><div><p>Active Members</p><strong>{{ member_stats.active }}</strong></div></div>
      <div class="organization-stat-card"><div><p>Pending Invitations</p><strong>{{ pending_invitations.length }}</strong></div></div>
      <div v-if="organization.is_private" class="organization-stat-card"><div><p>Pending Approvals</p><strong>0</strong></div></div>
    </section>

    <section v-if="active_management_tab === 'companies'" class="organization-members-stats">
      <div class="organization-stat-card"><div><p>Total Companies</p><strong>{{ company_stats.total }}</strong></div></div>
      <div class="organization-stat-card"><div><p>Active Companies</p><strong>{{ company_stats.active }}</strong></div></div>
      <div class="organization-stat-card"><div><p>Pending Setup</p><strong>{{ company_stats.pending }}</strong></div></div>
      <div class="organization-stat-card"><div><p>Inactive Companies</p><strong>{{ company_stats.inactive }}</strong></div></div>
    </section>

    <section v-if="active_management_tab === 'companies'" class="organization-members-panel mb-3">
      <div class="d-flex align-items-center justify-content-between p-1">
          <div class="d-flex align-items-center w-100 mb-2">
          <button
            v-if="can_manage_companies"
            class="btn btn-primary rounded text-xs px-3 fw-500 ms-auto"
            data-bs-toggle="modal"
            data-bs-target="#add_organization_company_modal"
            type="button"
            @click="open_company_form">
            <span>Add Company</span>
          </button>
        </div>
      </div>
      <div v-if="is_loading_companies" class="organization-members-empty py-4">Loading companies...</div>
      <div v-else-if="organization_companies.length" class="table-responsive organization-companies-table-shell">
        <table id="organization-companies-table" ref="organizationCompaniesTable" class="table table-hover align-middle mb-0 organization-members-table w-100">
          <thead><tr><th>Company</th><th>Manager</th><th>Employees</th><th>Status</th><th>Contact</th><th v-if="can_manage_members" class="text-end">Actions</th></tr></thead>
          <tbody>
            <tr v-for="company in organization_companies" :key="company.id">
              <td class="fw-500">{{ company.company_name }}</td>
              <td>{{ get_company_manager(company.id) }}</td>
              <td>{{ get_company_employee_count(company.id) }}</td>
              <td><span :class="['badge rounded-pill', company.is_active === false ? 'bg-secondary-subtle text-secondary' : 'bg-success-subtle text-success']">{{ company.is_active === false ? 'Inactive' : 'Active' }}</span></td>
              <td>{{ company.email || company.tell_number || 'Not provided' }}</td>
              <td v-if="can_manage_members" class="text-end">
                <div class="dropdown organization-member-menu">
                  <button class="btn btn-light btn-sm rounded border" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Manage company" aria-label="Manage company">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="open_add_member_modal(company.id)">
                        <i class="bi bi-person-plus"></i>
                        Add Member
                      </button>
                    </li>
                    <li>
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="open_invite_member_modal(company.id)">
                        <i class="bi bi-envelope-plus"></i>
                        Invite Member
                      </button>
                    </li>
                    <li v-if="can_manage_companies"><hr class="dropdown-divider" /></li>
                    <li v-if="can_manage_companies">
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="edit_organization_company(company)">
                        <i class="bi bi-pencil"></i>
                        Edit Company
                      </button>
                    </li>
                    <li v-if="can_manage_companies">
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="toggle_organization_company_status(company)">
                        <i :class="['bi', company.is_active === false ? 'bi-play-circle' : 'bi-pause-circle']"></i>
                        {{ company.is_active === false ? 'Activate Company' : 'Deactivate Company' }}
                      </button>
                    </li>
                    <li v-if="can_manage_companies">
                      <button class="dropdown-item text-danger text-xxs d-flex align-items-center gap-2" type="button" @click="delete_organization_company(company)">
                        <i class="bi bi-trash"></i>
                        Delete Company
                      </button>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="organization-members-empty py-4">
        <i class="bi bi-buildings"></i>
        <p>No companies have been added to this organisation.</p>
      </div>
    </section>

    <section v-if="active_management_tab === 'members'" class="organization-members-stats">
      <div class="organization-stat-card">
        <div class="organization-stat-icon">
          <i class="bi bi-person-check"></i>
        </div>
        <div>
          <p>Active Members</p>
          <strong>{{ member_stats.active }}</strong>
        </div>
      </div>

      <div class="organization-stat-card">
        <div class="organization-stat-icon">
          <i class="bi bi-envelope-exclamation"></i>
        </div>
        <div>
          <p>Pending Invites</p>
          <strong>{{ member_stats.pending }}</strong>
        </div>
      </div>
    </section>

    <section v-if="active_management_tab === 'members'" class="organization-members-panel">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <button
          v-if="can_manage_members"
          v-can-create="'members'"
          class="btn btn-primary rounded text-xs px-3 fw-500 ms-auto"
          data-bs-toggle="modal"
          data-bs-target="#add_organization_member_modal"
          type="button"
          @click="reset_bulk_member_form()">
          <span>Add Member</span>
        </button>
      </div>
      <div v-if="is_loading_members" class="organization-members-empty">
        <div class="spinner-border text-secondary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p>Loading members...</p>
      </div>

      <div v-else-if="accepted_members.length" class="organization-members-table-shell">
        <table id="organization-members-table" ref="organizationMembersTable" class="table table-hover align-middle organization-members-table w-100">
          <thead>
            <tr>
              <th>Member</th>
              <th>Company</th>
              <th>Email</th>
              <th>Status</th>
              <th v-if="can_manage_members" class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="member in accepted_members" :key="member.id" :data-member-id="member.id">
              <td>
                {{ member.first_name }} {{ member.last_name }}
              </td>
              <td>{{ get_company_name(member.company_id) }}</td>
              <td>{{ member.email || 'No email available' }}</td>
              <td>
                {{ member.invitation_status }}
              </td>
              <td v-if="can_manage_members" class="text-end">
                <div class="dropdown organization-member-menu">
                  <button class="btn btn-light btn-sm rounded border" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Manage member">
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <button class="dropdown-item text-xxs d-flex align-items-center gap-2" type="button" @click="open_manage_member(member)">
                        <i class="bi bi-sliders"></i>
                        Manage Access
                      </button>
                    </li>
                    <li>
                      <button class="dropdown-item text-danger text-xxs d-flex align-items-center gap-2" type="button" @click="remove_organization_member(member)">
                        <i class="bi bi-trash"></i>
                        Remove Member
                      </button>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else class="organization-members-empty">
        <i class="bi bi-people"></i>
        <h2>No members yet</h2>
        <p>Add users to give them access to this organisation workspace.</p>
      </div>
    </section>

    <section v-if="active_management_tab === 'invitations'" class="organization-members-panel">
      <div class="d-flex align-items-center justify-content-between p-3">
        <strong class="text-xs">Invitations</strong>
        <button v-if="can_manage_members" class="btn btn-primary rounded text-xs" data-bs-toggle="modal" data-bs-target="#invite_organization_member_modal" @click="reset_invite_form()">Create Invitation</button>
      </div>
      <div v-if="organization_invitations.length" class="table-responsive">
        <table id="organization-invitations-table" ref="organizationInvitationsTable" class="table table-hover align-middle mb-0 organization-members-table w-100">
          <thead><tr><th>Recipient</th><th>Company</th><th>Role</th><th>Invited</th><th>Expiry</th><th>Status</th></tr></thead>
          <tbody><tr v-for="member in organization_invitations" :key="member.id">
            <td>{{ member.email || 'Shared invitation' }}</td>
            <td>{{ get_company_name(member.company_id) }}</td>
            <td>{{ member.role || 'Employee' }}</td>
            <td>{{ format_invitation_date(member.invited_at) }}</td>
            <td>{{ format_invitation_date(member.invitation_expires_at) }}</td>
            <td><span :class="['badge', member.invitation_status === 'rejected' ? 'bg-danger' : 'bg-primary text-warning-emphasis']">{{ member.invitation_status === 'rejected' ? 'Rejected' : 'Pending' }}</span></td>
          </tr></tbody>
        </table>
      </div>
      <div v-else class="organization-members-empty"><i class="bi bi-envelope"></i><h2>No invitations</h2></div>
    </section>

    <section v-if="active_management_tab === 'approvals'" class="organization-members-panel">
      <div class="organization-members-empty"><i class="bi bi-person-check"></i><h2>No pending approval requests</h2><p>Requests from private-organisation invitations will appear here.</p></div>
    </section>
  </div>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="invite_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="inviteOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="inviteOrganizationMemberLabel">Invite Organisation Member</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="invite_organization_member">
            <div class="modal-body">
              <div class="organization-member-modal-tabs" role="tablist" aria-label="Organisation member action">
                <button class="organization-member-modal-tab active" type="button" role="tab" aria-selected="true">
                  <i class="bi bi-envelope-plus" aria-hidden="true"></i>
                  <span>Invite</span>
                </button>
                <button class="organization-member-modal-tab" type="button" role="tab" aria-selected="false" @click="open_add_member_modal(selected_company_id)">
                  <i class="bi bi-person-plus" aria-hidden="true"></i>
                  <span>Add Members</span>
                </button>
              </div>

              <div v-if="invite_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ invite_errors.form }}
              </div>

              <div class="organization-invite-methods" role="group" aria-label="Invite method">
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('email') }]"
                  @click="set_invite_method('email')"
                >
                  <i class="bi bi-envelope"></i>
                  <span>Email</span>
                </button>
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('link') }]"
                  @click="set_invite_method('link')"
                >
                  <i class="bi bi-link-45deg"></i>
                  <span>Link</span>
                </button>
                <button
                  type="button"
                  :class="['organization-invite-method', { active: invite_method_is('qr_code') }]"
                  @click="set_invite_method('qr_code')"
                >
                  <i class="bi bi-qr-code"></i>
                  <span>QR Code</span>
                </button>
              </div>

              <div v-if="invite_method_is('email')" class="organization-create-user-grid">
                <div>
                  <label class="form-label text-xxs fw-500 " for="invite_email">Email <span class="text-danger">*</span></label>
                  <input id="invite_email" v-model="invite_user.email" :class="['form-control rounded text-xxs', { 'is-invalid': invite_errors.email }]" type="email" placeholder="example@company.com" />
                  <div v-if="invite_errors.email" class="invalid-feedback text-xxs">{{ invite_errors.email }}</div>
                </div>
              </div>

              <div v-if="latest_invitation" :class="['organization-invite-share', { 'organization-invite-share-single': !invite_method_is('email') }]">
                <div v-if="!invite_method_is('qr_code')">
                  <p class="organization-invite-share-label">Invite link</p>
                  <div class="organization-invite-link-row">
                    <input class="form-control rounded text-xxs" :value="latest_invitation.link" readonly />
                    <div class="organization-invite-share-actions">
                      <button class="btn btn-light rounded border organization-share-icon-btn" type="button" title="Copy invite link" @click="copy_invitation_link">
                        <i class="bi bi-clipboard"></i>
                      </button>
                      <div class="dropdown organization-invite-share-menu">
                        <button
                          class="btn btn-light rounded border organization-share-icon-btn"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          title="Share invite link"
                        >
                          <i class="bi bi-three-dots"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end organization-invite-share-dropdown">
                          <a
                            :href="get_invitation_share_url('whatsapp')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-whatsapp text-success"></i>
                            <span>WhatsApp</span>
                          </a>
                          <a
                            :href="get_invitation_share_url('facebook')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-facebook text-primary"></i>
                            <span>Facebook</span>
                          </a>
                          <a
                            :href="get_invitation_share_url('linkedin')"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="dropdown-item"
                          >
                            <i class="bi bi-linkedin text-info"></i>
                            <span>LinkedIn</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!invite_method_is('link') && latest_invitation.qr_code" class="organization-invite-qr">
                  <img :src="invitation_qr_src()" alt="Organisation invite QR code" />
                  <div class="organization-invite-share-actions organization-invite-qr-actions">
                    <button class="btn btn-light rounded border organization-share-icon-btn" type="button" title="Download QR code" @click="download_invitation_qr">
                      <i class="bi bi-download"></i>
                    </button>
                    <div class="dropdown organization-invite-share-menu">
                      <button
                        class="btn btn-light rounded border organization-share-icon-btn"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        title="Share invite link"
                      >
                        <i class="bi bi-three-dots"></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-end organization-invite-share-dropdown">
                        <a
                          :href="get_invitation_share_url('whatsapp')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-whatsapp text-success"></i>
                          <span>WhatsApp</span>
                        </a>
                        <a
                          :href="get_invitation_share_url('facebook')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-facebook text-primary"></i>
                          <span>Facebook</span>
                        </a>
                        <a
                          :href="get_invitation_share_url('linkedin')"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="dropdown-item"
                        >
                          <i class="bi bi-linkedin text-info"></i>
                          <span>LinkedIn</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_inviting_member">
                {{ get_invite_submit_label() }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="add_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="addOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="addOrganizationMemberLabel">Add Organisation Members</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form class="organization-add-members-form" @submit.prevent="submit_add_member_modal">
            <div class="modal-body organization-add-members-body">
              <div class="organization-member-modal-tabs" role="tablist" aria-label="Organisation member action">
                <button class="organization-member-modal-tab" type="button" role="tab" aria-selected="false" @click="open_invite_member_modal(selected_company_id)">
                  <i class="bi bi-envelope-plus" aria-hidden="true"></i>
                  <span>Invite</span>
                </button>
                <button class="organization-member-modal-tab active" type="button" role="tab" aria-selected="true">
                  <i class="bi bi-person-plus" aria-hidden="true"></i>
                  <span>Add Members</span>
                </button>
              </div>

              <div v-if="bulk_member_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ bulk_member_errors.form }}
              </div>

              <div v-if="is_company_member_target()" class="border rounded p-3 mb-3 bg-light">
                <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
                  <div>
                    <strong class="text-xxs d-block">Assign existing organisation member</strong>
                    <small class="text-muted text-xxs">Choose someone already accepted in the organisation and assign them to {{ get_company_name(selected_company_id) }}.</small>
                  </div>
                </div>
                <div v-if="existing_company_member_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                  {{ existing_company_member_errors.form }}
                </div>
                <div v-if="assignable_company_members.length" class="mb-3">
                  <label class="form-label text-xxs fw-500" for="existing_company_member_search">Search organisation members</label>
                  <div class="input-group">

                    <input
                      id="existing_company_member_search"
                      v-model="existing_company_member_search"
                      class="form-control rounded text-xxs"
                      type="search"
                      placeholder="Search by name or email"
                    />
                  </div>
                  <div v-if="existing_company_member_errors.member_id" class="text-danger text-xxs mt-1">{{ existing_company_member_errors.member_id }}</div>
                  <div class="border rounded bg-white mt-2 overflow-auto" style="max-height: 180px;">
                    <button
                      v-for="member in filtered_assignable_company_members"
                      :key="member.id"
                      type="button"
                      :class="[
                        'dropdown-item text-xxs d-flex flex-column align-items-start py-2',
                        Number(existing_company_member.member_id) === Number(member.id) ? 'bg-primary text-white' : ''
                      ]"
                      @click="select_existing_company_member(member)"
                    >
                      <span class="fw-500">{{ member.first_name }} {{ member.last_name }}</span>
                      <small :class="Number(existing_company_member.member_id) === Number(member.id) ? 'text-white' : 'text-muted'">{{ member.email }}</small>
                    </button>
                    <div v-if="!filtered_assignable_company_members.length" class="text-muted text-xxs p-3">
                      No members match your search.
                    </div>
                  </div>
                </div>
                <div v-if="assignable_company_members.length" class="organization-create-user-grid">
                  <div>
                    <label class="form-label text-xxs fw-500" for="existing_company_member_role">Company Role <span class="text-danger">*</span></label>
                    <select id="existing_company_member_role" v-model="existing_company_member.role" :class="['form-select rounded text-xxs', { 'is-invalid': existing_company_member_errors.role }]">
                      <option value="user">Employee</option>
                      <option value="manager">Manager</option>
                    </select>
                    <div v-if="existing_company_member_errors.role" class="invalid-feedback text-xxs">{{ existing_company_member_errors.role }}</div>
                  </div>
                </div>
                <div v-else class="text-muted text-xxs">
                  No accepted organisation members are available for this company.
                </div>
                <div class="d-flex justify-content-end mt-3">
                  <button
                    type="button"
                    class="btn btn-primary btn-sm rounded text-xxs"
                    :disabled="is_assigning_existing_member || !existing_company_member.member_id"
                    @click="assign_existing_company_member"
                  >
                    {{ is_assigning_existing_member ? 'Assigning...' : 'Assign to Company' }}
                  </button>
                </div>
              </div>

              <div class="d-flex justify-content-end mb-3">
                <button type="button" class="btn btn-sm btn-primary rounded text-xxs" @click="add_bulk_member_row">
                  Add more
                </button>
              </div>

              <div v-for="(member, index) in bulk_members" :key="index" class="border rounded p-3 mb-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <strong class="text-xxs">Member {{ index + 1 }}</strong>
                  <button
                    type="button"
                    class="btn btn-light board-icon-btn d-none d-xl-flex align-items-center justify-content-center me-2"
                    title="Remove member row"
                    aria-label="Remove member row"
                    @click="remove_bulk_member_row(index)"
                  >
                    <i class="bi bi-x-lg" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="organization-create-user-grid">
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_first_name_${index}`">First Name <span class="text-danger">*</span></label>
                    <input :id="`member_first_name_${index}`" v-model="member.first_name" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.first_name }]" type="text" placeholder="Enter first name" />
                    <div v-if="bulk_member_errors.members[index]?.first_name" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].first_name }}</div>
                  </div>
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_last_name_${index}`">Last Name <span class="text-danger">*</span></label>
                    <input :id="`member_last_name_${index}`" v-model="member.last_name" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.last_name }]" type="text" placeholder="Enter last name" />
                    <div v-if="bulk_member_errors.members[index]?.last_name" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].last_name }}</div>
                  </div>
                  <div>
                    <label class="form-label text-xxs fw-500" :for="`member_email_${index}`">Email <span class="text-danger">*</span></label>
                    <input :id="`member_email_${index}`" v-model="member.email" :class="['form-control rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.email }]" type="email" placeholder="example@company.com" />
                    <div v-if="bulk_member_errors.members[index]?.email" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].email }}</div>
                  </div>
                  <div v-if="is_company_member_target()">
                    <label class="form-label text-xxs fw-500" :for="`member_role_${index}`">Role <span class="text-danger">*</span></label>
                    <select :id="`member_role_${index}`" v-model="member.role" :class="['form-select rounded text-xxs', { 'is-invalid': bulk_member_errors.members[index]?.role }]">
                      <option value="user">Employee</option>
                      <option value="manager">Manager</option>
                    </select>
                    <div v-if="bulk_member_errors.members[index]?.role" class="invalid-feedback text-xxs">{{ bulk_member_errors.members[index].role }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer organization-add-members-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_bulk_adding_members || is_assigning_existing_member">
                {{ get_add_member_submit_label() }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="manage_organization_member_modal" :style="branding_style" tabindex="-1" aria-labelledby="manageOrganizationMemberLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="manageOrganizationMemberLabel">Manage Member Access</p>
            <button
              type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="save_member_access">
            <div class="modal-body">
              <div v-if="selected_member" class="organization-manage-member-summary">
                <div class="organization-member-avatar">
                  <img v-if="get_member_profile_picture(selected_member)" :src="get_member_profile_picture(selected_member)" alt="Profile picture" />
                  <span v-else>{{ get_initials(selected_member) }}</span>
                </div>
                <div>
                  <h3>{{ selected_member.first_name }} {{ selected_member.last_name }}</h3>
                  <p>{{ selected_member.email }}</p>
                </div>
              </div>

              <div v-if="member_access_errors.form" class="alert alert-danger text-xxs py-2 mb-3" role="alert">
                {{ member_access_errors.form }}
              </div>

              <div v-if="is_loading_access_options" class="alert alert-light text-xxs py-2 mb-3" role="status">
                Loading organisation access options...
              </div>

              <p class="organization-access-card-intro">
                <i class="bi bi-info-circle-fill"></i>
                Select features and their permissions for this member.
              </p>

              <div v-if="organization_features.length" class="organization-feature-card-grid">
                <article v-for="feature in organization_features" :key="feature.id" :class="['organization-feature-card', { active: member_feature_is_enabled(feature) }]">
                  <header class="organization-feature-card-header">
                    <div class="organization-feature-card-title">
                      <i class="bi bi-layers-fill"></i>
                      <strong>{{ feature.name }}</strong>
                    </div>
                    <div class="organization-feature-card-actions">
                      <div class="form-check form-switch organization-access-switch">
                        <input class="form-check-input" type="checkbox" :checked="member_feature_is_enabled(feature)" :aria-label="`Toggle all ${feature.name} permissions`" @change="set_member_feature_enabled(feature, $event.target.checked)" />
                      </div>
                      <button class="organization-feature-chevron" type="button" :aria-expanded="member_feature_is_expanded(feature)" :aria-label="`${member_feature_is_expanded(feature) ? 'Collapse' : 'Expand'} ${feature.name}`" @click="toggle_member_feature_expanded(feature)">
                        <i :class="['bi', member_feature_is_expanded(feature) ? 'bi-chevron-up' : 'bi-chevron-down']"></i>
                      </button>
                    </div>
                  </header>
                  <div v-show="member_feature_is_expanded(feature)" class="organization-feature-permissions">
                    <label v-for="permission in get_assignable_permissions(feature)" :key="permission.id || permission.name" class="organization-feature-permission-row">
                      <span><i class="bi bi-circle-fill"></i>{{ permission.name }}</span>
                      <span class="form-check form-switch organization-access-switch">
                        <input class="form-check-input" type="checkbox" :checked="member_permission_is_enabled(feature, permission)" @change="set_member_permission_enabled(feature, permission, $event.target.checked)" />
                      </span>
                    </label>
                  </div>
                </article>
              </div>
              <p v-else-if="!is_loading_access_options" class="text-muted text-xxs mb-0">No organisation features are available.</p>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary text-xxs rounded" :disabled="is_saving_access || !organization_features.length">
                {{ is_saving_access ? 'Saving...' : 'Save Access' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>

  <teleport to="body">
    <div class="modal fade organization-members-modal" id="add_organization_company_modal" :style="branding_style" tabindex="-1" aria-labelledby="addOrganizationCompanyLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
            <p class="modal-title text-xxs fw-500" id="addOrganizationCompanyLabel">{{ editing_company_id ? 'Edit Company' : 'Add Company' }}</p>
            <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form @submit.prevent="submit_company_form">
            <div class="modal-body">
              <div v-if="company_errors.form" class="alert alert-danger text-xxs py-2">{{ company_errors.form }}</div>
              <div class="organization-create-user-grid">
                <div>
                  <label class="form-label text-xxs fw-500" for="company_name">Company Name <span class="text-danger">*</span></label>
                  <input id="company_name" v-model="new_company.company_name" :class="['form-control rounded text-xxs', { 'is-invalid': company_errors.company_name }]" type="text" />
                  <div v-if="company_errors.company_name" class="invalid-feedback text-xxs">{{ company_errors.company_name }}</div>
                </div>
                <div><label class="form-label text-xxs fw-500" for="company_email">Email</label><input id="company_email" v-model="new_company.email" class="form-control rounded text-xxs" type="email" /></div>
                <div><label class="form-label text-xxs fw-500" for="company_phone">Phone</label><input id="company_phone" v-model="new_company.tell_number" class="form-control rounded text-xxs" type="text" /></div>
                <div class="wide">
                  <label class="form-label text-xxs fw-500" for="company_location">Location</label>
                  <input id="company_location" ref="companyLocationInput" v-model="new_company.location" class="form-control rounded text-xxs" type="text" placeholder="Search location..." autocomplete="off" @focus="initialize_company_location_autocomplete" />
                </div>
                <div class="wide"><label class="form-label text-xxs fw-500" for="company_description">Description</label><textarea id="company_description" v-model="new_company.description" class="form-control rounded text-xxs" rows="3"></textarea></div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light rounded text-xxs" data-bs-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary rounded text-xxs" :disabled="is_creating_company || is_updating_company">{{ is_updating_company ? 'Saving...' : is_creating_company ? 'Creating...' : editing_company_id ? 'Save Changes' : 'Create Company' }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</div>
